export default function isStage(value) {
  const checkStage = (currentValue) => value.includes(currentValue);

  return import.meta.env.VITE_STAGE_DOMAIN_KEYWORDS.split(',').some(checkStage);
}
